<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h3>用户信息为：{{token}}</h3>
    <h3>登录地点：{{loginname}}</h3>
    <button @click="logout">登出</button>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'home',
  data () {
    return {
      msg: '系统一主页面',
      token:'',
      loginname:''
    }
  },
  mounted(){
    const token = Cookies.get('app.token');
    this.token = token;
    const loginname = Cookies.get('app.loginname');
    this.loginname = loginname;
    console.log(token);
    if(!token){
      this.$router.push("/login");
    }else{
      this.rethome()
    }
  },
  methods: {
    logout(){
        Cookies.set('app.token','', { expires: 1000, path: '/',domain: '.linheng.xyz'})
        Cookies.set('app.loginname','', { expires: 1000, path: '/',domain: '.linheng.xyz'})
        this.$router.go(0)
    },
    rethome(){
      var returl = Cookies.get('app.returl');
        if(returl){
          Cookies.set('app.returl','', { expires: 1000, path: '/',domain: '.linheng.xyz'})
          window.open(returl,"_parent");
        }else{
        }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue